import React from 'react';
import * as S from './styles';
import { Loading } from '../loading';
import { theme } from '../../styles/theme';

const CardCountMetric = ({ title, subtitle, value, trendPercent, trendLabel, isNew, loading, actions, stackTrend, ...props }) => {
    const hasTrend = trendPercent !== undefined && trendPercent !== null;
    const isPositive = hasTrend && trendPercent >= 0;

    return (
        <S.Container>
            <S.Header>
                <S.Title>{title}</S.Title>
                {actions}
            </S.Header>

            {subtitle && <S.Subtitle>{subtitle}</S.Subtitle>}

            {loading ? (
                <S.LoadingBox>
                    <Loading size="32px" color={theme.colors.green.Bandeira} noMargin />
                </S.LoadingBox>
            ) : (
                <S.ValueRow stackTrend={stackTrend}>
                    <S.Value>{value}</S.Value>

                    {hasTrend ? (
                        <S.Trend positive={isPositive}>
                            <span className="arrow">{isPositive ? '▲' : '▼'}</span>
                            <span className="percent">{isPositive ? '+' : ''}{trendPercent}%</span>
                            {trendLabel && <span className="label">{trendLabel}</span>}
                        </S.Trend>
                    ) : isNew && (
                        <S.Trend positive>
                            <span className="percent">Novo</span>
                        </S.Trend>
                    )}
                </S.ValueRow>
            )}
        </S.Container>
    )
}

export default CardCountMetric;
